import { createAction } from "redux-actions";
import { SEND_TRANSACTIONS_PAYMENT, GET_TRANSACTIONS_QR_PAYMENT, GET_TRANSACTION_MESSAGE } from "../constants";
import { serverGetQR, serverPaymentRequest, serverSendRequest } from "./../services/transactions";
// import { userActions } from "./../api/Auth";
import { urlTransactions, urlQRGenerator } from "./../services/urls";
import { feathersCreateData } from "../services";



export const sendRequestOLD = createAction(SEND_TRANSACTIONS_PAYMENT, 
    (serie, imei, number, amount, email, request, type, description) => 
    serverSendRequest(urlTransactions, serie, imei, number, amount, email, request, type, description)()) 

export const sendRequest = createAction(SEND_TRANSACTIONS_PAYMENT, 
        (mobile, cedule, amount, email, request, type, description) => 
        feathersCreateData('user-transactions', { mobile, cedule, amount, email, request, type, description })())

export const getQRPayment = createAction(GET_TRANSACTIONS_QR_PAYMENT, 
    (serie, imei, number, amount, request, emited, description) => 
    serverGetQR(urlQRGenerator, serie, imei, number, amount, request, emited, description)())

export const sendPayment = createAction(GET_TRANSACTION_MESSAGE, 
    (emited, serie, imei, number, amount, email, request, type, descripcion, qrState, qrcode) => 
    serverPaymentRequest(urlTransactions, emited,  serie, imei, number, amount, email, request, type, descripcion, qrState, qrcode)())
